import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorResponse } from './api-error.model';

export function getApiErrorKey(error: unknown): string | undefined {
  return error instanceof HttpErrorResponse
    ? (error.error as ApiErrorResponse | null)?.key
    : undefined;
}
